import { useEffect, useRef } from 'react';
import { getError } from '../../../utils/FormError';
import { useFormContext } from 'react-hook-form';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const InputPhone = ({
  name,
  placeholder = '',
  validationRules = {},
  onChange,
  autofocus = false,
  defaultCountry = 'MA',
}) => {
  const inputRef = useRef(null);
  const { register, setValue, formState: { errors } } = useFormContext();
  const error = getError(errors, name);

  const registration = register?.(name, validationRules) ?? {};
  const { ref: rhfRef, onChange: rhfOnChange, onBlur, name: inputName } = registration;

  const handleRef = (el) => {
    inputRef.current = el;
    if (typeof rhfRef === 'function') rhfRef(el);
    else if (rhfRef) rhfRef.current = el;
  };

  useEffect(() => {
    if (autofocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autofocus]);

  const handleChange = (e) => {
    const raw = e.target.value;

    const phoneNumber = parsePhoneNumberFromString(raw, defaultCountry);
    const formatted = phoneNumber ? phoneNumber.formatInternational() : raw;
    const e164 = phoneNumber ? phoneNumber.number : raw; // format E.164

    if (rhfOnChange) rhfOnChange(e); // facultatif mais safe

    setValue(name, e164, { shouldValidate: true });

    if (onChange) onChange(e);
  };

  return (
    <>
      <input
        type="tel"
        name={inputName}
        className={`form-control ${error ? 'is-invalid' : ''}`}
        placeholder={placeholder}
        onBlur={onBlur}
        onChange={handleChange}
        ref={handleRef}
      />
      {error && <div className="invalid-feedback">{error.message}</div>}
    </>
  );
};

export default InputPhone;
